import { useTranslation } from "react-i18next";

import { PrimaryButton } from "../../button/PrimaryButton";
import { LinkButton } from "../../link/LinkButton";
import { DialogFooter } from "../../modal/DialogFooter";

interface Props {
  onDone: () => void;
  action: string;
  clearable?: boolean;
  onClear?: () => void;
  testID: string;
  isDisabled?: boolean;
}

export function PickerFooter(props: Props) {
  const { t } = useTranslation();

  const { testID, isDisabled } = props;

  return (
    <DialogFooter
      leftContent={
        props.clearable && (
          <LinkButton
            onPress={props.onClear}
            linkStyle="monochrome"
            textColor="text-weak"
            testID={`${testID}-clear`}
          >
            {t("VERB Clear", "Clear")}
          </LinkButton>
        )
      }
      testID={testID}
    >
      <PrimaryButton
        onPress={props.onDone}
        testID={`${testID}-done`}
        isDisabled={isDisabled}
      >
        {props.action}
      </PrimaryButton>
    </DialogFooter>
  );
}
